import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputTextV6 from '@Common/InputTextV6/InputTextV6';
import DatePickerV6 from '@Common/DatePickerV6/DatePickerV6';
import { DATE_FORMAT } from '@Constants/constants';
import Moment from 'moment';
import ToggleV6 from '@Components/Common/ToggleV6/ToggleV6';
import MultiSelectBoxV6 from '@Components/Common/MultiSelectBoxV6/MultiSelectBoxV6';

export default class LocationForm extends Component {
    onFormChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    };

    onSingleSelectBoxChange = (id, name) => {
        this.props.onFormChange(name, id.toString());
    };

    onMultiSelectBoxChange = (csv, name) => {
        const newValue = csv ? csv.split(',') : [];
        this.props.onFormChange(name, newValue);
    };

    onDateChange = (value, name) => {
        this.props.onFormChange(name, value);
    };

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    };

    render() {
        return (
            <div className='location-form'>
                <form noValidate className={this.props.isFormValid ? '' : 'was-validated'}>
                    {/* Location/Team Information Section */}
                    <div className='mb-4'>
                        <h5 className='fw-bold mb-3'>Location/Team Information</h5>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputTextV6
                                    name='name'
                                    label='Location or Team Name'
                                    placeholder='Required'
                                    type='text'
                                    value={this.props.location.name}
                                    onChange={this.onFormChange}
                                    isRequired={true}
                                    errorMessage='Location or Team Name is required'
                                />
                                <MultiSelectBoxV6
                                    name='brandId'
                                    label='Brand'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.brands}
                                    onChange={this.onSingleSelectBoxChange}
                                    placeholder='Required'
                                    selectedValues={this.props.location.brandId.toString()}
                                    isRequired={true}
                                    errorMessage='Brand is required'
                                    isMulti={false}
                                />
                                <MultiSelectBoxV6
                                    name='locationTypeId'
                                    label='Type'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.locationTypes}
                                    onChange={this.onSingleSelectBoxChange}
                                    defaultValue='Required'
                                    selectedValues={this.props.location.locationTypeId.toString()}
                                    isRequired={true}
                                    errorMessage='Type is required'
                                    isMulti={false}
                                />
                                <DatePickerV6
                                    className='mb-3'
                                    showIcon
                                    label='Opening Date'
                                    placeholder='When does/did this location open?'
                                    name='openingDate'
                                    value={this.props.location.openingDate}
                                    onChange={this.onDateChange}
                                    isRequired={true}
                                    errorMessage='Opening Date is required'
                                    dateFormat='d M yy'
                                />
                            </div>
                            <div className='col-md-6'>
                                <InputTextV6
                                    name='abbreviation'
                                    placeholder='Required'
                                    label='Abbreviation'
                                    type='text'
                                    value={this.props.location.abbreviation}
                                    onChange={this.onFormChange}
                                    isRequired={true}
                                    errorMessage='Abbreviation is required'
                                />
                                <MultiSelectBoxV6
                                    name='managementCompanyId'
                                    label='Management Company'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.managementCompanies}
                                    onChange={this.onSingleSelectBoxChange}
                                    defaultValue='Required'
                                    selectedValues={this.props.location.managementCompanyId.toString()}
                                    isRequired={true}
                                    errorMessage='Management Company is required'
                                    isMulti={false}
                                />
                                <MultiSelectBoxV6
                                    name='locationTagIds'
                                    options={this.props.tags}
                                    idField='id'
                                    valueField='name'
                                    label='Tags'
                                    placeholder='Select all that apply'
                                    selectedValues={this.props.location.locationTagIds.toString()}
                                    onChange={this.onMultiSelectBoxChange}
                                    isMulti={true}
                                />
                                <InputTextV6
                                    name='generation'
                                    placeholder='Optional'
                                    label='Generation'
                                    type='text'
                                    value={this.props.location.generation}
                                    onChange={this.onFormChange}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Geography Details Section */}
                    <div className='mb-4'>
                        <h5 className='fw-bold mb-3'>Geography Details</h5>
                        <div className='row'>
                            <div className='col-md-6'>
                                <MultiSelectBoxV6
                                    name='areaId'
                                    label='Area'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.areas}
                                    onChange={this.onSingleSelectBoxChange}
                                    defaultValue='Required'
                                    selectedValues={this.props.location.areaId.toString()}
                                    isRequired={true}
                                    errorMessage='Area is required'
                                    isMulti={false}
                                />
                                <MultiSelectBoxV6
                                    name='countryId'
                                    label='Country'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.countries}
                                    onChange={this.onSingleSelectBoxChange}
                                    defaultValue='Required'
                                    selectedValues={this.props.location.countryId.toString()}
                                    isRequired={true}
                                    errorMessage='Country is required'
                                    isMulti={false}
                                />
                                <InputTextV6
                                    name='address'
                                    label='Address'
                                    placeholder='Optional'
                                    type='text'
                                    value={this.props.location.address}
                                    onChange={this.onFormChange}
                                />
                                <InputTextV6
                                    name='stateProvince'
                                    label='State/Province'
                                    placeholder='Optional'
                                    type='text'
                                    value={this.props.location.stateProvince}
                                    onChange={this.onFormChange}
                                />
                            </div>
                            <div className='col-md-6'>
                                <MultiSelectBoxV6
                                    name='regionId'
                                    label='Region'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.regions}
                                    onChange={this.onSingleSelectBoxChange}
                                    defaultValue='Required'
                                    selectedValues={this.props.location.regionId.toString()}
                                    isRequired={true}
                                    errorMessage='Region is required'
                                    isMulti={false}
                                />
                                <MultiSelectBoxV6
                                    name='continentId'
                                    label='Continent'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.continents}
                                    onChange={this.onSingleSelectBoxChange}
                                    defaultValue='Required'
                                    selectedValues={this.props.location.continentId.toString()}
                                    isRequired={true}
                                    errorMessage='Continent is required'
                                    isMulti={false}
                                />
                                <InputTextV6
                                    name='city'
                                    label='City'
                                    placeholder='Optional'
                                    type='text'
                                    value={this.props.location.city}
                                    onChange={this.onFormChange}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Additional Details Section */}
                    <div className='mb-4'>
                        <h5 className='fw-bold mb-3'>Additional Details</h5>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputTextV6
                                    name='generalManagerName'
                                    placeholder='Optional but suggested'
                                    label='General Manager Name'
                                    type='text'
                                    value={this.props.location.generalManagerName}
                                    onChange={this.onFormChange}
                                />
                                <InputTextV6
                                    name='division'
                                    placeholder='Optional'
                                    label='Division'
                                    type='text'
                                    value={this.props.location.division}
                                    onChange={this.onFormChange}
                                />
                                <MultiSelectBoxV6
                                    name='projectManagerIds'
                                    label='Project Managers'
                                    idField='id'
                                    valueField='name'
                                    options={this.props.projectManagers}
                                    onChange={this.onMultiSelectBoxChange}
                                    placeholder='Optional'
                                    selectedValues={this.props.location.projectManagerIds.toString()}
                                    isRequired={false}
                                    isMulti={true}
                                />
                            </div>
                            <div className='col-md-6'>
                                <InputTextV6
                                    name='generalManagerEmail'
                                    placeholder='Optional but suggested'
                                    label='General Manager Email'
                                    type='email'
                                    value={this.props.location.generalManagerEmail}
                                    onChange={this.onFormChange}
                                    isValid={this.props.isGeneralManagerEmailValid}
                                />
                                <InputTextV6
                                    name='unit'
                                    label='Unit'
                                    placeholder='Optional'
                                    type='text'
                                    value={this.props.location.unit}
                                    onChange={this.onFormChange}
                                />
                                <InputTextV6
                                    name='billingInfo'
                                    label='Info'
                                    placeholder='Optional'
                                    type='text'
                                    value={this.props.location.billingInfo}
                                    onChange={this.onFormChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col mb-3'>
                            <ToggleV6 name='isActive' text='Active' checked={this.props.location.isActive} onChange={this.onToggleChange} />
                        </div>
                    </div>

                    {this.props.location.id ? (
                        <div>
                            <div className='row'>
                                <div className='col'>
                                    {this.props.isUserEhAdmin ? (
                                        <InputTextV6 label='Id' name='id' isDisabled={true} type='text' value={this.props.location.id.toString()} />
                                    ) : null}
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <InputTextV6
                                        label='Created By'
                                        name='createdByName'
                                        isDisabled={true}
                                        type='text'
                                        value={this.props.location.createdByName}
                                    />
                                    <InputTextV6
                                        label='Created Date'
                                        name='createdDate'
                                        isDisabled={true}
                                        type='text'
                                        value={this.props.location.dateCreated}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <InputTextV6
                                        label='Modified By'
                                        name='modifiedByName'
                                        isDisabled={true}
                                        type='text'
                                        value={this.props.location.modifiedByName}
                                    />
                                    <InputTextV6
                                        label='Modified Date'
                                        name='modifiedDate'
                                        isDisabled={true}
                                        type='text'
                                        value={this.props.location.dateModified}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {this.props.trackingUpdates && this.props.trackingUpdates.length > 0 && (
                        <div>
                            <div className='mb-1'>
                                <strong>Opening Date Changes</strong>
                            </div>
                            <table className='table table-striped'>
                                <thead>
                                    <tr>
                                        <th>Old Value</th>
                                        <th>New Value</th>
                                        <th>Changed By</th>
                                        <th>Changed On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.trackingUpdates.map((update) => (
                                        <tr key={update.id}>
                                            <td>{Moment.utc(update.previousOpeningDate).format(DATE_FORMAT)}</td>
                                            <td>{Moment.utc(update.newOpeningDate).format(DATE_FORMAT)}</td>
                                            <td>{update.changedByName}</td>
                                            <td>{Moment.utc(update.changedDate).format(DATE_FORMAT)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </form>
            </div>
        );
    }
}

LocationForm.propTypes = {
    isFormValid: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    isUserEhAdmin: PropTypes.bool.isRequired,
    areas: PropTypes.array.isRequired,
    brands: PropTypes.array.isRequired,
    continents: PropTypes.array.isRequired,
    countries: PropTypes.array.isRequired,
    locationTypes: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    regions: PropTypes.array.isRequired,
    projectManagers: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isGeneralManagerEmailValid: PropTypes.bool.isRequired,
    trackingUpdates: PropTypes.array,
    tags: PropTypes.array,
};
